"use client";

// As soon as this module is _imported_, override console methods.
// This runs before React hydration (i.e. at module‐evaluation time).
if (typeof window !== "undefined") {
  if (process.env.NODE_ENV === "production") {
    console.error = () => {};
    console.warn = () => {};
  }
}

export default function ConsoleSuppressor() {
  return null; // no UI
}
